
          var atcButtons = document.querySelectorAll(
            '[action="/cart/add"] [name=add], .coll-atc-wrapper [data-action-atc]'
          );
          if (atcButtons.length) {
            atcButtons.forEach((atcButton) => {
              let allowSubmit = false;

              atcButton.addEventListener(
                'click',
                async function (e) {
                  if (allowSubmit) {
                    allowSubmit = false;
                    return;
                  }

                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();

                  try {
                    var res = await fetch('/cart.js');
                    var cart = await res.json();
                    var giftCardItem = cart.items.find((item) => item.gift_card);
                    console.log('giftCardItem', giftCardItem);

                    if (giftCardItem) {
                      await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ id: giftCardItem.key, quantity: 0 }),
                      });

                      allowSubmit = true;
                      atcButton.click();
                    } else {
                      allowSubmit = true;
                      atcButton.click();
                    }
                  } catch (err) {
                    console.error(err);
                  }
                },
                true
              );
            });
          }
        